import {library} from "@fortawesome/fontawesome-svg-core";
import {
    faLink,
    faPowerOff,
    faUser,
    faUsers,
    faBook,
    faBookOpen,
    faCheck,
    faTrash,
    faBars,
    faTimes,
    faPencilAlt,
    faSearch,
    faHome,
    faStar,
    faPlus,
    faChevronDown,
    faUpload,
    faSignInAlt,
    faBoxOpen,
    faSlidersH,
    faEllipsisV,
    faLock,
    faLockOpen,
    faCogs,
    faUserPlus,
    faUserMinus,
    faBullhorn
} from "@fortawesome/free-solid-svg-icons";

function initFontAwesome() {
    library.add(faLink);
    library.add(faUser);
    library.add(faUsers);
    library.add(faPowerOff);
    library.add(faBook);
    library.add(faBookOpen);
    library.add(faCheck);
    library.add(faTrash);
    library.add(faBars);
    library.add(faTimes);
    library.add(faPencilAlt);
    library.add(faSearch);
    library.add(faHome);
    library.add(faStar);
    library.add(faPlus);
    library.add(faChevronDown);
    library.add(faUpload);
    library.add(faSignInAlt);
    library.add(faBoxOpen);
    library.add(faSlidersH);
    library.add(faEllipsisV);
    library.add(faLock);
    library.add(faLockOpen);
    library.add(faCogs);
    library.add(faUserPlus);
    library.add(faUserMinus);
    library.add(faBullhorn);
}

export default initFontAwesome;
